import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getAllStocksEssay = async (TypeOf = "", Depot = "", TCP = "", EnterOrExit = "", FromYear = `${new Date().getFullYear()}-01-01`, ToYear = `${new Date().getFullYear()+1}-01-01`, Product = "", Category = "", page) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/StockEssay/getAll/${id}/${iv}?Type=${TypeOf.length === 0 ? "" : JSON.stringify(TypeOf)}&Depot=${Depot}&TCP=${TCP}&EnterOrExit=${EnterOrExit}&FromYear=${FromYear}&ToYear=${ToYear}&Product=${Product}&Category=${Category}&limit=10&page=${page}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllStocksExcelEssay = async (TypeOf = "", Depot = "", TCP = "", EnterOrExit = "", FromYear = `${new Date().getFullYear()}-01-01`, ToYear = `${new Date().getFullYear()+1}-01-01`, Product = "", Category = "") => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/StockEssay/getAllExcel/${id}/${iv}?Type=${TypeOf.length === 0 ? "" : JSON.stringify(TypeOf)}&Depot=${Depot}&TCP=${TCP}&EnterOrExit=${EnterOrExit}&FromYear=${FromYear}&ToYear=${ToYear}&Product=${Product}&Category=${Category}`, option);
        return res.data
    }
    catch (error) {
        throw error
    }
}

export const getOneStockEssayApi = async (stockID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/StockEssay/getOne/${id}/${iv}/${stockID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteStockTransfertEssayApi = async (stockID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/StockEssay/deleteStockTransfert/${id}/${iv}/${stockID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
